import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.k51_1 = 1048576;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var FinalClass;
function Final() {
  if (FinalClass === VOID) {
    class $ extends Final_1() {
      static o51(lo, hi, isBits) {
        var $this = this.q51(isBits);
        $this.m51_1 = lo;
        $this.n51_1 = hi;
        return $this;
      }
      static r51(lo, hi) {
        return this.o51(lo, hi, false);
      }
      cf() {
        return this.m51_1;
      }
      df() {
        return this.n51_1;
      }
      s51() {
        if (this.p51_1)
          return this;
        return Final().o51(this.m51_1 << 3, this.n51_1 << 3 | (this.m51_1 >>> 29 | 0), true);
      }
    }
    initMetadataForClass($, 'Final');
    FinalClass = $;
  }
  return FinalClass;
}
function init_org_kotlincrypto_bitops_bits_Counter_Bit32(_this__u8e3s4) {
}
var FinalClass_0;
function Final_0() {
  if (FinalClass_0 === VOID) {
    class $ extends Final_1() {}
    initMetadataForClass($, 'Final');
    FinalClass_0 = $;
  }
  return FinalClass_0;
}
var Bit32Class;
function Bit32() {
  if (Bit32Class === VOID) {
    class $ extends Counter() {
      static x51(lo, hi, incrementBy) {
        var $this = this.z51();
        init_org_kotlincrypto_bitops_bits_Counter_Bit32($this);
        // Inline function 'kotlin.require' call
        if (!(incrementBy > 0)) {
          var message = 'incrementBy[' + incrementBy + '] must be greater than 0';
          throw IllegalArgumentException().a1(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(incrementBy <= 1048576)) {
          var message_0 = 'incrementBy[' + incrementBy + '] must be less than or equal to 1048576';
          throw IllegalArgumentException().a1(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!((incrementBy % 8 | 0) === 0)) {
          var message_1 = 'incrementBy[' + incrementBy + '] must be a factor of 8';
          throw IllegalArgumentException().a1(toString(message_1));
        }
        // Inline function 'kotlin.require' call
        if (!((-2147483648 % incrementBy | 0) === 0)) {
          var message_2 = 'Int.MIN_VALUE % incrementBy[' + incrementBy + '] != 0';
          throw IllegalArgumentException().a1(toString(message_2));
        }
        // Inline function 'kotlin.require' call
        if (!((lo % incrementBy | 0) === 0)) {
          var message_3 = 'lo must be a factor of incrementBy[' + incrementBy + ']';
          throw IllegalArgumentException().a1(toString(message_3));
        }
        $this.u51_1 = incrementBy;
        $this.v51_1 = lo;
        $this.w51_1 = hi;
        return $this;
      }
      static a52(incrementBy) {
        return this.x51(0, 0, incrementBy);
      }
      b52() {
        this.v51_1 = this.v51_1 + this.u51_1 | 0;
        if (this.v51_1 === 0) {
          this.w51_1 = this.w51_1 + 1 | 0;
        }
      }
      c52(additional) {
        var lo = this.v51_1;
        var hi = this.w51_1;
        var lt0 = lo < 0;
        lo = lo + additional | 0;
        if (lt0 && lo >= 0) {
          hi = hi + 1 | 0;
        }
        return Final().r51(lo, hi);
      }
      d52() {
        this.v51_1 = 0;
        this.w51_1 = 0;
      }
    }
    initMetadataForClass($, 'Bit32');
    Bit32Class = $;
  }
  return Bit32Class;
}
var Bit64Class;
function Bit64() {
  if (Bit64Class === VOID) {
    class $ extends Counter() {}
    initMetadataForClass($, 'Bit64');
    Bit64Class = $;
  }
  return Bit64Class;
}
var FinalClass_1;
function Final_1() {
  if (FinalClass_1 === VOID) {
    class $ {
      static q51(isBits) {
        var $this = createThis(this);
        $this.p51_1 = isBits;
        return $this;
      }
      equals(other) {
        var tmp;
        if (other instanceof Final_1()) {
          tmp = hashCode(other) === this.hashCode();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var result = 17;
        if (this instanceof Final()) {
          result = imul(result, 31) + this.m51_1 | 0;
          result = imul(result, 31) + this.n51_1 | 0;
        } else {
          if (this instanceof Final_0()) {
            result = imul(result, 31) + getBigIntHashCode(this.f52_1) | 0;
            result = imul(result, 31) + getBigIntHashCode(this.g52_1) | 0;
          }
        }
        result = imul(result, 31) + getBooleanHashCode(this.p51_1) | 0;
        return result;
      }
      toString() {
        var tmp;
        if (this instanceof Final()) {
          tmp = 'Counter.Bit32.Final[lo=' + this.m51_1 + ', hi=' + this.n51_1 + ']';
        } else {
          if (this instanceof Final_0()) {
            tmp = 'Counter.Bit64.Final[lo=' + this.f52_1.toString() + ', hi=' + this.g52_1.toString() + ']';
          } else {
            noWhenBranchMatchedException();
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'Final');
    FinalClass_1 = $;
  }
  return FinalClass_1;
}
var CounterClass;
function Counter() {
  if (CounterClass === VOID) {
    class $ {
      static z51() {
        var $this = createThis(this);
        $this.y51_1 = new Object();
        return $this;
      }
      equals(other) {
        var tmp;
        if (other instanceof Counter()) {
          tmp = hashCode(other) === this.hashCode();
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return 527 + hashCode(this.y51_1) | 0;
      }
      toString() {
        var tmp;
        if (this instanceof Bit32()) {
          tmp = 'Bit32[lo=' + this.v51_1 + ', hi=' + this.w51_1 + ', incrementBy=' + this.u51_1 + ']';
        } else {
          if (this instanceof Bit64()) {
            tmp = 'Bit64[lo=' + this.j52_1.toString() + ', hi=' + this.k52_1.toString() + ', incrementBy=' + this.i52_1.toString() + ']';
          } else {
            noWhenBranchMatchedException();
          }
        }
        // Inline function 'kotlin.let' call
        return 'Counter.' + tmp + '@' + this.hashCode();
      }
    }
    initMetadataForClass($, 'Counter');
    CounterClass = $;
  }
  return CounterClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Bit32 as Bit3217m1n1f00xdaa,
};
//endregion

//# sourceMappingURL=Counter.mjs.map
